<template>
  <v-card
    @click="() => typeof widget.data.link!=='undefined' ? move(widget.data.link) : null"
    v-if="widget.type==='tile' && widget.data.template==='defaultDesignDens'"
    :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color "
    dark
  >
    <v-card-text v-if="widget.data.model!=='no'" style="padding: 2px 24px !important;">
      <span class="text-h5" style="font-size: 12px !important;" v-html="widget.data.title"></span>
      <v-btn text>
        {{ widget.data.model }} {{ widget.data.prefix }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import router from "@/router";

export default {
  name: "tile-default-design-dens",
  props: {
    widget: Object
  },
  methods: {
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style scoped>

</style>
